const hawkin_csv_metrics = {
  'Jump Height': 'jump_height_hawkin',
  'Jump Momentum': 'jump_momentum_hawkin',
  'Countermovement Depth': 'countermovement_depth_hawkin',
  'Braking RFD': 'braking_rfd_hawkin',
  'Stiffness': 'stiffness_hawkin',
  'Force at Min Displacement': 'force_at_min_displacement_hawkin',
  'Relative Force at Min Displacement': 'relative_force_at_min_displacement_hawkin',
  'Avg. Braking Force': 'avg_braking_force_hawkin',  
  'Avg. Relative Braking Force': 'avg_relative_braking_force_hawkin',
  'Peak Braking Force': 'peak_braking_force_hawkin',
  'Peak Relative Braking Force': 'peak_relative_braking_force_hawkin',
  'Avg. Propulsive Force': 'avg_propulsive_force_hawkin',
  'Avg. Relative Propulsive Force': 'lr_avg_relative_propulsive_force_hawkin',
  'Peak Propulsive Force': 'peak_propulsive_force_hawkin',
  'Peak Relative Propulsive Force': 'peak_relative_propulsive_force_hawkin',
  'Unweighting Phase': 'unweighting_phase_hawkin',
  'Unweighting Phase %': 'unweighting_phase_percent_hawkin',
  'Braking Phase': 'braking_phase_hawkin',
  'Braking Phase %': 'braking_phase_percent_hawkin',
  'Propulsive Phase': 'propulsive_phase_hawkin',
  'Propulsive Phase %': 'propulsive_phase_percent_hawkin',
  'Flight Time': 'flight_time_hawkin',
  'Time To Takeoff': 'time_to_takeoff_hawkin',
  'Braking Net Impulse': 'braking_net_impulse_hawkin',
  'Propulsive Net Impulse': 'propulsive_net_impulse_hawkin',
  'Positive Impulse': 'positive_impulse_hawkin',
  'Positive Net Impulse': 'positive_net_impulse_hawkin',
  'Impulse Ratio': 'impulse_ratio_hawkin',
  'Avg. Braking Velocity': 'avg_braking_velocity_hawkin',
  'Peak Braking Velocity': 'peak_braking_velocity_hawkin',
  'Avg. Propulsive Velocity': 'avg_propulsive_velocity_hawkin',
  'Takeoff Velocity': 'takeoff_velocity_hawkin',
  'Peak Velocity': 'peak_velocity_hawkin',
  'Avg. Braking Power': 'avg_braking_power_hawkin',
  'Avg. Relative Braking Power': 'avg_relative_braking_power_hawkin',
  'Peak Braking Power': 'peak_braking_power_hawkin',
  'Peak Relative Braking Power': 'peak_relative_braking_power_hawkin',
  'Avg. Propulsive Power': 'avg_propulsive_power_hawkin',
  'Avg. Relative Propulsive Power': 'avg_relative_propulsive_power_hawkin',
  'Peak Relative Propulsive Power': 'peak_relative_propulsive_power_hawkin',
  'Peak Propulsive Power': 'peak_propulsive_power_hawkin',
  'L|R Peak Braking Force': 'lr_peak_braking_force_hawkin',
  'Left Force at Peak Braking Force': 'left_force_at_peak_braking_force_hawkin',
  'Right Force at Peak Braking Force': 'right_force_at_peak_braking_force_hawkin',
  'L|R Avg. Braking Force': 'lr_avg_braking_force_hawkin',
  'Left Avg. Braking Force': 'left_avg_braking_force_hawkin',
  'Right Avg. Braking Force': 'right_avg_braking_force_hawkin',
  'L|R Peak Propulsive Force': 'lr_peak_propulsive_force_hawkin',
  'Left Force at Peak Propulsive Force': 'left_force_at_peak_propulsive_force_hawkin',
  'Right Force at Peak Propulsive Force': 'right_force_at_peak_propulsive_force_hawkin',
  'L|R Avg. Propulsive Force': 'lr_avg_propulsive_force_hawkin',
  'Left Avg. Propulsive Force': 'left_avg_propulsive_force_hawkin',
  'Right Avg. Propulsive Force': 'right_avg_propulsive_force_hawkin',
  'L|R Avg. Braking RFD': 'lr_avg_braking_rfd_hawkin',
  'Left Avg. Braking RFD': 'left_avg_braking_rfd_hawkin',
  'Right Avg. Braking RFD': 'right_avg_braking_rfd_hawkin',
  'L|R Braking Impulse Index': 'lr_braking_impulse_index_hawkin',
  'L|R Propulsive Impulse Index': 'lr_propulsive_impulse_index_hawkin',
  'Time to Stabilization': 'time_to_stabilization_hawkin',
  'Landing Stiffness': 'landing_stiffness_hawkin',
  'Peak Landing Force': 'peak_landing_force_hawkin',
  'Avg. Landing Force': 'avg_landing_force_hawkin',
  'Relative Peak Landing Force': 'relative_peak_landing_force_hawkin',
  'L|R Peak Landing Force': 'lr_peak_landing_force_hawkin',
  'Left Force at Peak Landing Force': 'left_force_at_peak_landing_force_hawkin',
  'Right Force at Peak Landing Force': 'right_force_at_peak_landing_force_hawkin',
  'L|R Avg. Landing Force': 'lr_avg_landing_force_hawkin',
  'Left Avg. Landing Force': 'left_avg_landing_force_hawkin',
  'Right Avg. Landing Force': 'right_avg_landing_force_hawkin',
  'L|R Landing Impulse Index': 'lr_landing_impulse_index_hawkin',
  'Braking Impulse': 'braking_impulse_hawkin',
  'Relative Braking Impulse': 'relative_braking_impulse_hawkin',
  'Relative Braking Net Impulse': 'relative_braking_net_impulse_hawkin',
  'Propulsive Impulse': 'propulsive_impulse_hawkin',
  'Relative Propulsive Impulse': 'relative_propulsive_impulse_hawkin',
  'Relative Propulsive Net Impulse': 'relative_propulsive_net_impulse_hawkin',
}

export function fp_metrics(team_name) {
  const all = {
    "braking_net_impulse": "Braking Net Impulse(N.s)",
    "braking_rfd": "Braking RFD(N/s)",
    "concentric_mean_force_bm": "Avg. Relative Propulsive Force(%)",
    "concentric_mean_power_bm": "Avg. Relative Propulsive Power(W/kg)",
    "concentric_peak_force": "Peak Propulsive Force(N)",
    "countermovement_depth": "Countermovement Depth",
    // "countermovement_depth": "Countermovement Depth(cm)",
    "drive": "Drive",
    "drive_t_score": "Drive (T Score)",
    "eccentric_braking_rfd": "Eccentric Braking RFD(N/s)",
    "eccentric_mean_braking_force_bm": "Avg. Relative Braking Force(%)",
    "eccentric_peak_force": "Eccentric Peak Force [N]",
    "eccentric_time": "Eccentric Time(ms)",
    "explode": "Explode",
    "explode_t_score": "Explode (T Score)",
    "force_at_min_displacement": "Force at Min Displacement(N)",
    "force_at_peak_power": "Force at Peak Power(N)",
    "force_at_zero_velocity": "Force at Zero Velocity(N)",
    "impulse_ratio": "Impulse Ratio",
    "jump_height": "Jump Height(m)",
    "jump_height_flight_time_inch": "Jump Height(in)",
    "jump_momentum": "Jump Momentum(kg.m/s)",
    "load": "Load",
    "load_t_score": "Load (T Score)",
    "lr_avg_braking_force": "L|R Avg. Braking Force(%)",
    "lr_avg_landing_force": "L|R Avg. Landing Force(%)",
    "lr_propulsive_impulse_index": "L|R Propulsive Impulse Index(%)",
    "mRSI": "mRSI",
    "peak_braking_velocity": "Avg. Braking Velocity(m/s)",
    "peak_power": "Peak Propulsive Power(W)",
    "peak_power_bm": "Peak Relative Propulsive Power(W/kg)",
    "propulsive_net_impulse": "Propulsive Net Impulse(N.s)",
    "relative_peak_landing_force": "Relative Peak Landing Force(%)",
    "rsi": "RSI",
    "rsi_modified": "RSI - Modified",
    "stiffness": "Stiffness(N/m)",
    "time_to_takeoff": "Time To Takeoff(s)",
    "jump_height_imp_mom": "Jump Height - Impulse Momentum (cm)",
    "rsi_modified": "RSI - Modified",
    "eccentric_decel_rfd_bm": "Eccentric Deceleration RFD / BM (N/s/kg)",
    "eccentric_peak_power_bm": "Eccentric Peak Power / BM (W)",
    "peak_power_bm": "Peak Power / BM (W/kg)",
    "concentric_mean_force_bm": "Concentric Mean Force / BM (N/kg)",
    "concentric_impulse": "Concentric Impulse (N.s)"   
}

  let hawkin_csv = {}
  Object.entries(hawkin_csv_metrics).map(arr => {hawkin_csv[arr[1]] = arr[0]})

  const team_based_metrics = {
    'Purdue Football': {
      'concentric_peak_force': 'Concentric Peak Force(N)',
      'eccentric_peak_force': 'Eccentric peak force [N]',
      'peak_power': 'Peak Power [W]',
      'jump_height_flight_time_inch': 'Jump Height(in)',
      'load': 'Load',
      'explode': 'Explode',
      'drive': 'Drive',
      'load_t_score': 'Load (T Score)',
      'explode_t_score': 'Explode (T Score)',
      'drive_t_score': 'Drive (T Score)',
    },

    'Georgia Tech Football': {
      'jump_height': 'Jump Height(m)',
      'mRSI': 'mRSI',
      'load': 'Load',
      'explode': 'Explode',
      'drive': 'Drive',
      'load_t_score': 'Load (T Score)',
      'explode_t_score': 'Explode (T Score)',
      'drive_t_score': 'Drive (T Score)',
    },

    'Orlando Pride': {
      "countermovement_depth": "Countermovement Depth(m)",
      "jump_height_flight_time_inch": "Jump Height(in)",
      "rsi_modified": "RSI - Modified",
      "force_at_zero_velocity": "Force at Zero Velocity(N)",
      "eccentric_time": "Eccentric Time(ms)",
      "load": "Load",
      'explode': 'Explode',
      "drive": "Drive",
      // 'load_t_score': 'Load (T Score)',
      // 'explode_t_score': 'Explode (T Score)',
      // 'drive_t_score': 'Drive (T Score)',
      "eccentric_braking_rfd": "Eccentric Braking RFD(N/s)",
      "force_at_peak_power": "Force at Peak Power - Asym(N)",
    },

    'Illinois Football': {
      'jump_height': 'Jump Height(m)',
      'jump_momentum': 'Jump Momentum(kg.m/s)',
      'countermovement_depth': 'Countermovement Depth(m)',
      'stiffness': 'Stiffness(N/m)',
      'eccentric_mean_braking_force_bm': 'Avg. Relative Braking Force(%)',
      // 'concentric_peak_force': 'Peak Propulsive Force(N)',
      'peak_power': 'Peak Propulsive Power(W)',
      'concentric_mean_force_bm': 'Avg. Relative Propulsive Force(%)',
      'concentric_mean_power_bm': 'Avg. Relative Propulsive Power(W/kg)',
      'peak_power_bm': 'Peak Relative Propulsive Power(W/kg)',
      'braking_rfd': 'Braking RFD(N/s)',
      'rsi': 'RSI',
      'mRSI': 'mRSI',
      'time_to_takeoff': 'Time To Takeoff(s)',
      'peak_braking_velocity': 'Avg. Braking Velocity(m/s)',
      'lr_propulsive_impulse_index': 'L|R Propulsive Impulse Index(%)',
      'relative_peak_landing_force': 'Relative Peak Landing Force(%)',
      'force_at_min_displacement': 'Force at Min Displacement(N)',
      'braking_net_impulse': 'Braking Net Impulse(N.s)',
      'propulsive_net_impulse': 'Propulsive Net Impulse(N.s)',
      'impulse_ratio': 'Impulse Ratio',

      'right_avg_propulsive_force': 'Right Avg. Propulsive Force(N)',
      'left_avg_propulsive_force': 'Left Avg. Propulsive Force(N)',
      'lr_avg_propulsive_force': 'L|R Avg. Propulsive Force(%)',

      'left_peak_propulsive_force': 'Left Force at Peak Propulsive Force(N)',
      'right_peak_propulsive_force': 'Right Force at Peak Propulsive Force(N)',
      'lr_peak_propulsive_force': 'L|R Peak Propulsive Force(%)',

      'left_avg_landing_force': 'Left Avg. Landing Force(N)',
      'right_avg_landing_force': 'Right Avg. Landing Force(N)',
      'lr_avg_landing_force': 'L|R Avg. Landing Force(%)',

      'left_peak_landing_force': 'Left Force at Peak Landing Force(N)',
      'right_peak_landing_force': 'Right Force at Peak Landing Force(N)',
      'lr_peak_landing_force': 'L|R Peak Landing Force(%)',

      'left_peak_braking_force': 'Left Force at Peak Braking Force(N)',
      'right_peak_braking_force': 'Right Force at Peak Braking Force(N)',
      'lr_peak_braking_force': 'L|R Peak Braking Force(%)',

      'left_avg_braking_force': 'Left Avg. Braking Force(N)',
      'right_avg_braking_force': 'Right Avg. Braking Force(N)',
      'lr_avg_braking_force': 'L|R Avg. Braking Force(%)'

    },

    'FAU Football': {
      "jump_height_flight_time_inch": "Jump Height(in)",
      'jump_momentum': 'Jump Momentum(kg.m/s)',
      'countermovement_depth': 'Countermovement Depth(m)',
      'stiffness': 'Stiffness(N/m)',
      'eccentric_mean_braking_force_bm': 'Avg. Relative Braking Force(%)',
      'concentric_peak_force': 'Peak Propulsive Force(N)',
      'peak_power': 'Peak Propulsive Power(W)',
      'concentric_mean_force_bm': 'Avg. Relative Propulsive Force(%)',
      'concentric_mean_power_bm': 'Avg. Relative Propulsive Power(W/kg)',
      'peak_power_bm': 'Peak Relative Propulsive Power(W/kg)',
      'braking_rfd': 'Braking RFD(N/s)',
      'rsi': 'RSI',
      'mRSI': 'mRSI',
      'time_to_takeoff': 'Time To Takeoff(s)',
      'peak_braking_velocity': 'Avg. Braking Velocity(m/s)',
      'lr_avg_braking_force': 'L|R Avg. Braking Force(%)',
      'lr_propulsive_impulse_index': 'L|R Propulsive Impulse Index(%)',
      'lr_avg_landing_force': 'L|R Avg. Landing Force(%)',
      'relative_peak_landing_force': 'Relative Peak Landing Force(%)',
      'force_at_min_displacement': 'Force at Min Displacement(N)',
      'braking_net_impulse': 'Braking Net Impulse(N.s)',
      'propulsive_net_impulse': 'Propulsive Net Impulse(N.s)',
      'impulse_ratio': 'Impulse Ratio',
    },

    'Temple University Football': {
      "concentric_impulse": "Concentric Impulse (N.s)",
      'concentric_peak_force': 'Peak Propulsive Force(N)',
      'peak_power': 'Peak Propulsive Power(W)',
      "jump_height_flight_time_inch": "Jump Height(in)",
      'eccentric_peak_force': 'Eccentric peak force [N]',
      'rsi_modified': "RSI - Modified",
      "force_at_zero_velocity": "Force at Zero Velocity(N)",
      "eccentric_time": "Eccentric Time(ms)",
      "eccentric_braking_rfd": "Eccentric Braking RFD(N/s)",
      "force_at_peak_power": "Force at Peak Power(N)",
      'countermovement_depth': 'Countermovement Depth(m)',
      'stiffness': 'Stiffness(N/m)',
      'concentric_mean_force_bm': 'Avg. Relative Propulsive Force(%)',
      "jump_height_imp_mom": "Jump Height - Impulse Momentum (cm)",
      "eccentric_decel_rfd_bm": "Eccentric Deceleration RFD / BM (N/s/kg)",
      "eccentric_peak_power_bm": "Eccentric Peak Power / BM (W)",
      'peak_power_bm': 'Peak Relative Propulsive Power(W/kg)',
    },

    'N2AthleteX': {
      "concentric_impulse": "Concentric Impulse (N.s)",
      'concentric_peak_force': 'Peak Propulsive Force(N)',
      'peak_power': 'Peak Propulsive Power(W)',
      "jump_height_flight_time_inch": "Jump Height(in)",
      'eccentric_peak_force': 'Eccentric peak force [N]',
      'rsi_modified': "RSI - Modified",
      "force_at_zero_velocity": "Force at Zero Velocity(N)",
      "eccentric_time": "Eccentric Time(ms)",
      "eccentric_braking_rfd": "Eccentric Braking RFD(N/s)",
      "force_at_peak_power": "Force at Peak Power(N)",
      'countermovement_depth': 'Countermovement Depth(m)',
      'stiffness': 'Stiffness(N/m)',
      'concentric_mean_force_bm': 'Avg. Relative Propulsive Force(%)',
      "jump_height_imp_mom": "Jump Height - Impulse Momentum (cm)",
      "eccentric_decel_rfd_bm": "Eccentric Deceleration RFD / BM (N/s/kg)",
      "eccentric_peak_power_bm": "Eccentric Peak Power / BM (W)",
      'peak_power_bm': 'Peak Relative Propulsive Power(W/kg)',
    },

    "UMass Lowell Women's Soccer": {
      "jump_height_flight_time_inch": "Jump Height(in)",
      'jump_momentum': 'Jump Momentum(kg.m/s)',
      'countermovement_depth': 'Countermovement Depth(m)',
      'stiffness': 'Stiffness(N/m)',
      'eccentric_mean_braking_force_bm': 'Avg. Relative Braking Force(%)',
      'concentric_peak_force': 'Peak Propulsive Force(N)',
      'peak_power': 'Peak Propulsive Power(W)',
      'concentric_mean_force_bm': 'Avg. Relative Propulsive Force(%)',
      'concentric_mean_power_bm': 'Avg. Relative Propulsive Power(W/kg)',
      'peak_power_bm': 'Peak Relative Propulsive Power(W/kg)',
      'braking_rfd': 'Braking RFD(N/s)',
      'rsi': 'RSI',
      'mRSI': 'mRSI',
      'time_to_takeoff': 'Time To Takeoff(s)',
      'peak_braking_velocity': 'Avg. Braking Velocity(m/s)',
      'lr_avg_braking_force': 'L|R Avg. Braking Force(%)',
      'lr_propulsive_impulse_index': 'L|R Propulsive Impulse Index(%)',
      'lr_avg_landing_force': 'L|R Avg. Landing Force(%)',
      'relative_peak_landing_force': 'Relative Peak Landing Force(%)',
      'force_at_min_displacement': 'Force at Min Displacement(N)',
      'braking_net_impulse': 'Braking Net Impulse(N.s)',
      'propulsive_net_impulse': 'Propulsive Net Impulse(N.s)',
      'impulse_ratio': 'Impulse Ratio',
    },

    "Northeastern University Women's Soccer": {
      'jump_height': 'Jump Height(m)',
      'jump_momentum': 'Jump Momentum(kg.m/s)',
      'countermovement_depth': 'Countermovement Depth(m)',
      'stiffness': 'Stiffness(N/m)',
      'eccentric_mean_braking_force_bm': 'Avg. Relative Braking Force(%)',
      'concentric_peak_force': 'Peak Propulsive Force(N)',
      'peak_power': 'Peak Propulsive Power(W)',
      'concentric_mean_force_bm': 'Avg. Relative Propulsive Force(%)',
      'concentric_mean_power_bm': 'Avg. Relative Propulsive Power(W/kg)',
      'peak_power_bm': 'Peak Relative Propulsive Power(W/kg)',
      'braking_rfd': 'Braking RFD(N/s)',
      'rsi': 'RSI',
      'mRSI': 'mRSI',
      'time_to_takeoff': 'Time To Takeoff(s)',
      'peak_braking_velocity': 'Avg. Braking Velocity(m/s)',
      'lr_avg_braking_force': 'L|R Avg. Braking Force(%)',
      'lr_propulsive_impulse_index': 'L|R Propulsive Impulse Index(%)',
      'lr_avg_landing_force': 'L|R Avg. Landing Force(%)',
      'relative_peak_landing_force': 'Relative Peak Landing Force(%)',
      'force_at_min_displacement': 'Force at Min Displacement(N)',
      'braking_net_impulse': 'Braking Net Impulse(N.s)',
      'propulsive_net_impulse': 'Propulsive Net Impulse(N.s)',
      'impulse_ratio': 'Impulse Ratio',
    },
    "Minnesota Men's Basketball": {
      'jump_height': 'Jump Height(m)',
      'jump_momentum': 'Jump Momentum(kg.m/s)',
      'countermovement_depth': 'Countermovement Depth(m)',
      'stiffness': 'Stiffness(N/m)',
      'eccentric_mean_braking_force_bm': 'Avg. Relative Braking Force(%)',
      'concentric_peak_force': 'Peak Propulsive Force(N)',
      'peak_power': 'Peak Propulsive Power(W)',
      'concentric_mean_force_bm': 'Avg. Relative Propulsive Force(%)',
      'concentric_mean_power_bm': 'Avg. Relative Propulsive Power(W/kg)',
      'peak_power_bm': 'Peak Relative Propulsive Power(W/kg)',
      'braking_rfd': 'Braking RFD(N/s)',
      'rsi': 'RSI',
      'mRSI': 'mRSI',
      'braking_net_impulse': 'Braking Net Impulse(N.s)',
      'force_at_min_displacement': 'Force at Min Displacement(N)',
      'impulse_ratio': 'Impulse Ratio',
      'lr_avg_braking_force': 'L|R Avg. Braking Force(%)',
      'lr_propulsive_impulse_index': 'L|R Propulsive Impulse Index(%)',
      'lr_avg_landing_force': 'L|R Avg. Landing Force(%)',
      'peak_braking_velocity': 'Avg. Braking Velocity(m/s)',
      'propulsive_net_impulse': 'Propulsive Net Impulse(N.s)',
      'relative_peak_landing_force': 'Relative Peak Landing Force(%)',
      'time_to_takeoff': 'Time To Takeoff(s)',
    }, 
    "South Carolina WBB": {
      "jump_height_imp_mom": "Jump Height - Impulse Momentum (cm)",
      "rsi_modified": "RSI - Modified",
      "eccentric_decel_rfd_bm": "Eccentric Deceleration RFD / BM (N/s/kg)",
      "eccentric_peak_power_bm": "Eccentric Peak Power / BM (W)",
      "peak_power_bm": "Peak Power / BM (W/kg)",
      "concentric_impulse": "Concentric Impulse (N.s)"
    },
    "Texas A&M Football": hawkin_csv
  }

  return team_based_metrics[team_name] || all

}

export const custom_fp_metrics = {
  'Illinois Football': [
    'lr_avg_braking_force',
    'lr_propulsive_impulse_index',
    'lr_avg_landing_force',
    'relative_peak_landing_force',
    'jump_height',
    'jump_momentum'
  ],
  'Football Demo Team': [
    'jump_height',
    'mRSI',
    'peak_power_bm',
    'concentric_mean_force_bm'
  ],
  'Purdue Football': [
    'eccentric_peak_force',
    'concentric_peak_force',
    'peak_power',
    'jump_height_flight_time_inch'
  ],
  'Mississippi Football': [
    'jump_height',
    'mRSI',
    'propulsive_net_impulse',
    'braking_net_impulse'
  ],
  'Orlando Pride': [
    'jump_height_flight_time_inch',
    'rsi_modified',
    'force_at_zero_velocity',
    'eccentric_time'
  ]

}

export function fp_metric_name_to_key(metric_name, teamName){
  // if (teamName == "Illinois Football"){

  // }
  return metric_name;
  let fp_metric_mapping = fp_metrics(teamName)
  return Object.keys(fp_metric_mapping).find(key => fp_metric_mapping[key] === metric_name);
}

export function get_ELD_chart_colors(team_name) {
  if(team_name == "Georgia Tech Football") {
    return {
      "bar": ["#0a3861", "#b4a063", "#000000"],
      "text": "#fff"
    }
  }
  return {
    "bar": ["#6f98d8", "#9bbce9", "#ccdcf3"],
    "text": "#fff"
  }
}